export default {
  _setOrGet(field, val) {
    if (val !== undefined) {
      if(val !== null) {
        console.log(field + ": " + val)
        localStorage.setItem(field, val)
      } else {
        console.log('rm ' + field)
        localStorage.removeItem(field)
      }
    } else {
      return localStorage.getItem(field)
    }
  },
  _setOrGetJson(field, val) {
    if (val !== undefined) {
      this._setOrGet(field, val !== null ? JSON.stringify(val) : null)
    } else {
      return JSON.parse(this._setOrGet(field, val))
    }
  },
  _clear() {
    this.sid(null)
    this.details(null)
    this.publisher(null)
    this.demand(null)
    this.company(null)
    this.exchange(null)
  },
  sid (sid) {
    return this._setOrGet('sid', sid)
  },
  perms () {
    let details = this.details()
    return details ? details.permissions : []
  },
  hasPerm (perm) {
    let perms = this.perms()
    if (!perms) {
      return false
    }
    return (perms.indexOf(perm) !== -1)
  },
  details (details) {
    return this._setOrGetJson('details', details)
  },
  publisher (pub) {
    return this._setOrGetJson('publisher', pub)
  },
  exchange (ex) {
    return this._setOrGetJson('exchange', ex)
  },
  demand (bidder) {
    return this._setOrGetJson('demand', bidder)
  },
  company (company) {
    return this._setOrGetJson('company', company)
  },
  login (res) {
    this._clear()

    this.sid(res.sid)
    this.details(res.details)
    this.publisher(res.publisher)
    this.exchange(res.exchange)
    this.demand(res.bidder)
    this.company(res.company)
  },
  isAdmin () {
    return this.hasPerm('ADMIN')
  },
  isSuperAdmin() {
    return this.hasPerm("SUPER_ADMIN")
  },
  isAuthenticated () {
    return this.sid() != null
  },
  logout () {
    localStorage.removeItem('sid')
    localStorage.removeItem('details')
  }
}



// WEBPACK FOOTER //
// ./src/auth.js